import React, { FC, useState } from 'react';
import Button from '../../base/ButtonBase';
import { LinearGradient } from 'expo-linear-gradient';
import styles from './styles';

export type LinearGradientButtonProps = {
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;

  /**
   * onPress handler
   */
  onPress: (e: any) => void;

  /**
   * Style of the text
   */
  textStyle?: any;

  /**
   * Title of the button
   */
  title: string;

  /**
   * Style - any general style over ride
   */
  style?: any;

  /**
   * An alternative to passing a onPress handler you can pass a url
   */
  url?: string;
};

export const LinearGradientButton: FC<LinearGradientButtonProps> = (props) => {
  const { disabled, onPress, style, title, url } = props;
  const linearGradient = ['#f4ac73', '#F17386', '#986ACB'];

  return (
    <LinearGradient
      colors={linearGradient}
      start={{ x: 0, y: 1 }}
      style={styles.gradient}
    >
      <Button
        containerStyle={[styles.container, style]}
        disabled={disabled}
        disabledContainerStyle={styles.disabledStyle}
        hoverTextStyle={styles.hoverTextStyle}
        hoverStyle={styles.hoverStyle}
        onPress={onPress}
        textStyle={styles.text}
        title={title}
        url={url}
      />
    </LinearGradient>
  );
};

export default LinearGradientButton;
